import React, {useState, useEffect, useContext} from 'react'
import {MainContext} from '../../App';
// import ccFetch from '../../Helpers/ccFetch'
import { fetch as authFetch } from '../../Helpers/auth';

let DEFAULT_USER_MOREINFO = {
  telCelular: "",
  telFixo: "",
  dataNascimento: "",
}

export default function Page_Usuarios_MinhaConta (props) {
  const { user={}, setUser } = useContext(MainContext);
  const { alias, email, scope } = user;
  let {REACT_APP_API_URL, REACT_APP_PROTOCOL} = process.env;
  const [ dados, setDados ] = useState({});
  const setDado = (key, newValue) => setDados({ ...dados, [key]: newValue })
  const [ editando, setEditando ] = useState(false);
  let url_getUser = `${REACT_APP_PROTOCOL}://${REACT_APP_API_URL}/usuarios/${alias}`
  let url_setUser = `${REACT_APP_PROTOCOL}://${REACT_APP_API_URL}/usuarios`
  useEffect(() => {
    authFetch(url_getUser)
      .then(r => r.json())
      .then(r => {
        // console.log('sucesso no fetch: ', r)
        setDados({ ...DEFAULT_USER_MOREINFO, ...r })
      })
      .catch(err => {
        // console.log('falha no fetch: ', err)
        if (err.status == 404) {
          setDados(DEFAULT_USER_MOREINFO)
        }
        // console.log(err);
      })
  }, [])

  return (
    <div>
      <h1>Minha Conta</h1>
      <div><b>Alias:</b> {alias}</div>
      <div><b>E-mail:</b> {email}</div>
      <div><b>Escopos:</b> {scope.join(', ')}</div>
      {Object.entries(dados).map(([ key, val ]) => {
        return (
          <div>
            <b>{key}:</b> 
            {editando ? (
              <input type="text" value={dados[key]} onChange={e => setDado(key, e.target.value)} />
            ) : (val)}
          </div>
        )
      })}
      { editando ? (
        <div>
          <button onClick={() => {
            // console.log(dados)
            // console.log(JSON.stringify(dados))
            authFetch(url_setUser, { method: 'PUT', body: JSON.stringify(dados) })
              .then(r => { 
                // console.log(r);
                // console.log('SALVANDO DADOS DO USUÁRIO!') 
              })
          }}>Salvar alterações campos</button>
        </div>
      ) : (
        <div>
          <button onClick={() => setEditando(true)}>Editar campos</button>
        </div>
      )}
    </div>
  )
}

